module.exports = __webpack_public_path__ + "static/media/avatar.2071dc85.svg";